// extracted by mini-css-extract-plugin
module.exports = {"input":"delete-price_input_1Zhaz","inputContainer":"delete-price_inputContainer_2z8At"};